/**
 * KpiRow — single row of the "$ per FTE" table inside the Zone-3
 * disclosure. Renders a horizontal progress bar from current vs max
 * annualised value, plus a headroom badge so the user can see what
 * they'd unlock by closing the gap to 100% PE.
 */
import React from 'react';

export default function KpiRow({ row }) {
  const pctOfMax = Math.max(0, Math.min(100, row.pct_of_max || 0));
  return (
    <div className="pie-kpi-row" data-testid={`pie-kpi-row-${row.kpi_id}`}>
      <div className="pie-kpi-row-head">
        <div className="pie-kpi-row-name">
          <span className="pie-kpi-row-improves" aria-hidden>↑</span>
          <span>{row.name}</span>
        </div>
        <div className="pie-kpi-row-numbers">
          <span className="pie-mono pie-kpi-row-current">${(row.current_value_yr || 0).toLocaleString()}</span>
          <span className="pie-kpi-row-period">/yr</span>
          <span className="pie-kpi-row-of">of</span>
          <span className="pie-mono pie-kpi-row-max">${(row.max_value_yr || 0).toLocaleString()}</span>
        </div>
      </div>
      <div className="pie-kpi-row-bar">
        <div className="pie-kpi-row-bar-fill" style={{ width: `${pctOfMax}%` }} />
      </div>
      <div className="pie-kpi-row-foot">
        <span>{pctOfMax}% of your role&apos;s annual potential</span>
        {row.headroom_yr > 0 && (
          <span className="pie-kpi-row-headroom">
            ${(row.headroom_yr).toLocaleString()}/yr headroom
          </span>
        )}
      </div>
    </div>
  );
}
